class LoadingManager {
  constructor() {
    this.overlay = document.getElementById('loading-overlay')
    this.progressBar = document.getElementById('progress-bar')
    this.loadingText = document.getElementById('loading-text')
    this.totalAssets = 0
    this.loadedAssets = 0
  }

  setTotal(total) {
    this.totalAssets = total
  }

  increment(message = 'Loading...') {
    this.loadedAssets++
    if (this.loadingText) this.loadingText.textContent = message
    if (this.progressBar) {
      this.progressBar.style.width = `${(this.loadedAssets / this.totalAssets) * 100}%`
    }
    
    if (this.loadedAssets >= this.totalAssets) {
      setTimeout(() => {
        this.complete();
      }, 1000);
    }
  }

  complete() {
    if (this.overlay) {
      this.overlay.classList.add('hidden')
    }
  }
}

export default LoadingManager;
